import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { extractSystemStyles } from '@famly/mf_system_system-props';
import { Text } from '@famly/mf_data-display_text';
import { Icon } from '@famly/mf_data-display_icon';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { useTooltipRequiredProps } from '@famly/mf_data-display_tooltip';
import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
import { useResponsiveSize } from '@famly/mf_util_breakpoints';
export const StatusPill = (props) => {
    const { text, id, size: sizeFromProps, variant = 'contained', severity, showDot, icon, ref } = props;
    const size = useResponsiveSize(sizeFromProps);
    const dataProps = useDataProps(props);
    const tooltipRequiredProps = useTooltipRequiredProps(props);
    const { sx: alignmentSx } = extractSystemStyles(props);
    const theme = useTheme();
    const backgroundColor = theme.modernFamlyTheme.colorPalette[getBackgroundColor(severity)];
    const foregroundColorKey = getForegroundColor(severity);
    const borderColor = theme.modernFamlyTheme.colorPalette[getBorderColor(severity)];
    return (_jsxs(Stack, { ref: ref, id: id, display: "inline-flex", direction: "row", alignItems: "center", gap: icon ? 1 : 2, height: size === 'regular' ? '32px' : '24px', paddingRight: 3, paddingLeft: !showDot && !icon ? 3 : 2, borderRadius: "24px", bgcolor: variant === 'contained' ? backgroundColor : 'transparent', sx: theme => ({
            ...alignmentSx(theme),
            border: variant === 'contained' ? `1px solid ${borderColor}` : 'none',
        }), ...dataProps, ...tooltipRequiredProps, children: [showDot && !icon ? _jsx(Dot, { color: foregroundColorKey }) : null, icon ? _jsx(Icon, { name: icon, size: size === 'regular' ? 20 : 16, color: foregroundColorKey }) : null, _jsx(Text, { variant: "subtitle", ellipsis: true, color: "n400", children: text })] }));
};
StatusPill.displayName = 'StatusPill';
const Dot = (props) => {
    const theme = useTheme();
    return (_jsx(Box, { height: "8px", width: "8px", borderRadius: "4px", bgcolor: theme.modernFamlyTheme.colorPalette[props.color], "data-e2e-class": "dot" }));
};
const getForegroundColor = (severity) => {
    switch (severity) {
        case 'info':
            return 'b400';
        case 'neutral':
            return 'n300';
        case 'error':
            return 'r400';
        case 'warning':
            return 'y400';
        case 'success':
            return 'g400';
        default:
            exhaustiveCheck(severity);
            return 'b400';
    }
};
const getBackgroundColor = (severity) => {
    switch (severity) {
        case 'info':
            return 'b50';
        case 'neutral':
            return 'n50';
        case 'error':
            return 'r50';
        case 'warning':
            return 'y50';
        case 'success':
            return 'g50';
        default:
            exhaustiveCheck(severity);
            return 'b50';
    }
};
const getBorderColor = (severity) => {
    switch (severity) {
        case 'info':
            return 'b400';
        case 'neutral':
            return 'n300';
        case 'error':
            return 'r400';
        case 'warning':
            return 'y400';
        case 'success':
            return 'g400';
        default:
            exhaustiveCheck(severity);
            return 'b400';
    }
};
